import React from 'react';
import { usersForAllRoles, ROLE_LABELS } from '../../auth/roles.js';

// "Available to" chips — computed by evaluating the article's visibleTo()
// predicate against a pseudo-user per role (see usersForAllRoles), never
// hand-written. Universal articles collapse to a single "Everyone" chip.
// Kept out of primitives.jsx so article content stays auth-free.
export default function RoleChips({ visibleTo }) {
  const users = usersForAllRoles();
  const allowed = users.filter(u => {
    try { return !!visibleTo(u); } catch { return false; }
  });
  if (allowed.length === users.length) {
    return (
      <span className="kb-chips" title="Roles that can use this feature">
        <span className="kb-chips-label">Available to</span>
        <span className="kb-chip everyone">Everyone</span>
      </span>
    );
  }
  return (
    <span className="kb-chips" title="Roles that can use this feature">
      <span className="kb-chips-label">Available to</span>
      {allowed.map(u => (
        <span key={u.role} className="kb-chip">{ROLE_LABELS[u.role] || u.role}</span>
      ))}
    </span>
  );
}
